// extracted by mini-css-extract-plugin
export default {"container":"Tr-z","brandName":"Ur-z","productName":"Vr-z","productNamePdpEnhancements":"Wr-z","breakLongProductName":"Xr-z"};